import PluginVector from './PluginVector';
import './style/index.less';

export default PluginVector;
